// Constants
import { onlyNumber } from '../../constants/normalize'

export const lawsuitNumber = value => {
  let lawsuitNumberOnlyNumber = onlyNumber(value)

  if (lawsuitNumberOnlyNumber.length >= 14) {
    lawsuitNumberOnlyNumber = '0'.repeat(20 - lawsuitNumberOnlyNumber.length) + lawsuitNumberOnlyNumber

    return `${lawsuitNumberOnlyNumber.slice(0, 7)}-${lawsuitNumberOnlyNumber.slice(7, 9)}.${lawsuitNumberOnlyNumber.slice(9, 13)}.${lawsuitNumberOnlyNumber.slice(13, 14)}.${lawsuitNumberOnlyNumber.slice(14, 16)}.${lawsuitNumberOnlyNumber.slice(16, 20)}`
  }

  return value
}

export const oabNumber = (value) => {
  if (!value || value.length > 6) return value

  if (value.length <= 6) {
    value = value.toUpperCase()
    value = value.match(/[a-zA-Z0-9]+/)
    value = '0'.repeat(6 - value[0].length) + value

    return value
  }
}

export const formatImporterDate = (date) => {
  let day = date.slice(0, 2)
  let month = date.slice(3, 5)
  let year = date.slice(6, date.length)
  let newDate
  let newMonth

  if (month === '12') {
    newDate = new Date(year, month - 1, day)
    newMonth = newDate.getMonth() + 1
  }
  else {
    newDate = new Date(year, month, day)
    newMonth = newDate.getMonth()
  }

  console.log(newDate.getDate())
  let dateFormat =
    newDate.getFullYear().toString().slice(-4) + "/" + newMonth + "/" + ('0' + newDate.getDate()).slice(-2)
  console.log(dateFormat)
  return dateFormat
}